export interface Emotion {
  word: string;
  dimension: '任务' | '人际' | '时间' | '空间';
}

export const emotions: Emotion[] = [
  { word: '耗竭', dimension: '任务' },
  { word: '兴奋', dimension: '任务' },
  { word: '投入', dimension: '任务' },
  { word: '困惑', dimension: '任务' },
  { word: '两难', dimension: '任务' },
  { word: '懈怠', dimension: '任务' },
  { word: '满意', dimension: '任务' },
  { word: '忍耐', dimension: '任务' },
  { word: '得心应手', dimension: '任务' },
  { word: '沮丧', dimension: '任务' },
  { word: '雀跃', dimension: '任务' },
  { word: '茫然', dimension: '任务' },
  { word: '焦虑', dimension: '任务' },
  { word: '松快', dimension: '任务' },
  { word: '乏味', dimension: '任务' },
  { word: '失望', dimension: '人际' },
  { word: '害羞', dimension: '人际' },
  { word: '心虚', dimension: '人际' },
  { word: '心软', dimension: '人际' },
  { word: '孤单', dimension: '人际' },
  { word: '羡慕', dimension: '人际' },
  { word: '自卑', dimension: '人际' },
  { word: '信任', dimension: '人际' },
  { word: '亲近', dimension: '人际' },
  { word: '排斥', dimension: '人际' },
  { word: '鄙夷', dimension: '人际' },
  { word: '生气', dimension: '人际' },
  { word: '憋屈', dimension: '人际' },
  { word: '优越', dimension: '人际' },
  { word: '惦记', dimension: '人际' },
  { word: '感动', dimension: '人际' },
  { word: '心碎', dimension: '人际' },
  { word: '迷恋', dimension: '人际' },
  { word: '心动', dimension: '人际' },
  { word: '嫉妒', dimension: '人际' },
  { word: '亏欠', dimension: '人际' },
  { word: '温暖', dimension: '人际' },
  { word: '无聊', dimension: '时间' },
  { word: '着急', dimension: '时间' },
  { word: '从容', dimension: '时间' },
  { word: '怀念', dimension: '时间' },
  { word: '遗憾', dimension: '时间' },
  { word: '期待', dimension: '时间' },
  { word: '悠闲', dimension: '时间' },
  { word: '紧迫', dimension: '时间' },
  { word: '煎熬', dimension: '时间' },
  { word: '空虚', dimension: '时间' },
  { word: '充实', dimension: '时间' },
  { word: '压抑', dimension: '空间' },
  { word: '舒适', dimension: '空间' },
  { word: '自在', dimension: '空间' },
  { word: '拘谨', dimension: '空间' },
  { word: '窒息', dimension: '空间' },
  { word: '浮躁', dimension: '空间' },
  { word: '踏实', dimension: '空间' },
  { word: '束缚', dimension: '空间' },
  { word: '舒展', dimension: '空间' },
  { word: '轻盈', dimension: '空间' },
  { word: '沉静', dimension: '空间' },
  { word: '暴露', dimension: '空间' },
];